/**
 * <TutorEarningsCardSkeleton> — la forme du mois du masteur pendant le premier chargement.
 *
 * Le cas courant : un compte Stripe rempli, quatre chiffres. L'intitulé, « Mon mois », ne dépend
 * d'aucune donnée : il s'écrit. Les onglets des périodes gardent leur rangée.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { Card } from "../../molecules/Card"
import { TabsSkeleton } from "../../molecules/Tabs"
import { List } from "../../molecules/List"
import { TUTOR_EARNINGS_TITLE } from "./TutorEarningsCard"

const TILES = ["validatedHours", "pendingHours", "validatedAmount", "pendingAmount"]

export function TutorEarningsCardSkeleton() {
    return (
        <List title={TUTOR_EARNINGS_TITLE}>
            <Card p="4">
                <Stack gap="4">
                    <TabsSkeleton size="sm" widths={[70, 104]} />
                    <View style={styles.tiles}>
                        {TILES.map((tile) => (
                            <View key={tile} style={styles.tile}>
                                <Skeleton textSize="text-2xl" width={64} />
                                <Skeleton textSize="text-sm" width={96} />
                            </View>
                        ))}
                    </View>
                </Stack>
            </Card>
        </List>
    )
}

const styles = StyleSheet.create((theme) => ({
    tiles: {
        flexDirection: "row",
        flexWrap: "wrap",
        rowGap: theme.spacing["3"],
        columnGap: theme.spacing["4"],
    },
    tile: {
        flexGrow: 1,
        flexBasis: "40%",
        minWidth: 110,
    },
}))
